import { useContext } from "react";
import { Example } from "./Example";
import { AppStateContext } from "../../state/AppProvider";

interface Props {
    onExampleClicked: (value: string) => void;
    onExampleClickedNoDocument: () => void;
}

export const ExampleList = ({ onExampleClicked, onExampleClickedNoDocument }: Props) => {
    const appStateContext = useContext(AppStateContext);

    const handleClick = (value: string) => {
        if (appStateContext?.state.files?.length === 0 && value === "Please summarise this document") {
            appStateContext?.dispatch({
                type: "SET_SUMMARISE_EXAMPLE_NO_DOCUMENT",
                payload: true
            });
        } else {
            onExampleClicked(value);
        }
    };

    return (
        <ul className="flex flex-wrap gap-4 justify-center">
            {appStateContext?.state.assistant?.examples.map((x, i) => (
                <li key={i} className="lg:last:list-item last:hidden">
                    <Example text={x} value={x} onClick={handleClick} />
                </li>
            ))}
        </ul>
    );
};
